<template>
  <div class="statistic">
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <statistic></statistic>
      </div>
    </div>
  </div>
</template>

<script>
  import Statistic from '@/views/Statistic/components/Statistic.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      Statistic
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/Statistic/Statistic.vue?af06524c